'use client';
import { factory, Box, Grid, Flex, Typography, DsmColor, omitText } from '@kohler-dsm-library/kohler-core';
import { CloseIcon, ArrowLeftIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React, { useState, isValidElement } from 'react';
import { TabbedNavigationHorizontal } from '../../../TabbedNavigationHorizontal/TabbedNavigationHorizontal.mjs';
import { RegionItem } from '../RegionItem/RegionItem.mjs';
import classes from './LanguageMenu.module.css.mjs';

const LanguageMenu = factory((props, ref) => {
  const { regions, heading, copy, currentCounty, className, setIsOpenMobileMenu, setMenuType, id = "language-menu", ...rest } = props;
  const [selectedRegionName, setSelectedRegionName] = useState();
  const classNames = clsx(className, "kohler-language-menu-root", classes.languageMenu);
  const tabs = regions.map(({ countries, name, ...rest2 }) => ({
    id: name,
    text: name,
    ...rest2
  }));
  const selectedRegion = regions.find((region) => region.name === selectedRegionName);
  const selectedRegionTabs = selectedRegion || regions[0];
  return /* @__PURE__ */ React.createElement(Box, { id, component: "div", ref, className: classNames, ...rest }, tabs.length > 0 && /* @__PURE__ */ React.createElement(
    TabbedNavigationHorizontal,
    {
      align: "center",
      initialSelectedTab: tabs[0]?.id,
      tabs,
      onTabClick: setSelectedRegionName,
      className: classes.languageMenuTab
    }
  ), /* @__PURE__ */ React.createElement(Grid, { className: clsx("center-grid", classes.languageMenuContentWrapper) }, /* @__PURE__ */ React.createElement(Flex, { className: classes.languageMenuContent }, /* @__PURE__ */ React.createElement(Typography, { size: "navigation-overlay-title", className: classes.languageMenuTitle, textColor: DsmColor.ContentPrimary }, heading.text), copy && /* @__PURE__ */ React.createElement(
    Typography,
    {
      className: classes.languageMenuCopy,
      component: isValidElement(copy.text) ? "div" : copy.component || "p",
      size: "paragraph-medium",
      textColor: DsmColor.ContentSecondary,
      ...omitText(copy)
    },
    copy.text
  )), selectedRegionTabs && /* @__PURE__ */ React.createElement("ul", { className: classes.languageMenuContentList }, selectedRegionTabs.countries.map((country) => {
    const { name, languages, ...rest2 } = country;
    return /* @__PURE__ */ React.createElement(
      "li",
      {
        key: country.name,
        className: clsx(
          classes.languageMenuContentListItem,
          currentCounty === name && classes.languageMenuContentListCurrentItem
        )
      },
      /* @__PURE__ */ React.createElement(RegionItem, { name, languages, ...rest2 })
    );
  }))), /* @__PURE__ */ React.createElement(Grid, { className: clsx(classes.languageMenuContentWrapperMobile), rowGap: 30 }, /* @__PURE__ */ React.createElement(Flex, { className: classes.languageMenuMobileClose }, /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "button",
      type: "button",
      onClick: () => {
        setMenuType?.(null);
        setIsOpenMobileMenu?.(false);
      },
      className: classes.languageMenuMobileCloseIcon
    },
    /* @__PURE__ */ React.createElement(CloseIcon, { withBoundingBox: false, size: "medium" })
  ), /* @__PURE__ */ React.createElement(
    Typography,
    {
      size: "label-regular-m",
      component: "button",
      type: "button",
      textColor: DsmColor.ContentSecondary,
      className: classes.languageMenuMobileBackText,
      onClick: () => selectedRegionName ? setSelectedRegionName(void 0) : setMenuType?.(null)
    },
    /* @__PURE__ */ React.createElement(ArrowLeftIcon, { withBoundingBox: false, size: "small" }),
    " ",
    selectedRegionName ? "Region" : "Menu"
  )), /* @__PURE__ */ React.createElement(Flex, { component: "ul", className: clsx(classes.languageMenuContentWrapperMobileLevelOne) }, !selectedRegionName ? /* @__PURE__ */ React.createElement(React.Fragment, null, tabs.map((tab) => /* @__PURE__ */ React.createElement("li", { key: tab.id }, /* @__PURE__ */ React.createElement(
    Typography,
    {
      size: "navigation-overlay-item-l",
      textColor: DsmColor.ContentActionDefault,
      component: "button",
      type: "button",
      ...omitText(tab),
      onClick: () => setSelectedRegionName(tab.id)
    },
    tab.text
  )))) : /* @__PURE__ */ React.createElement(React.Fragment, null, selectedRegionTabs.countries.map((region) => /* @__PURE__ */ React.createElement("li", { key: region.name }, /* @__PURE__ */ React.createElement(RegionItem, { ...region })))))));
});

export { LanguageMenu };
